// src/store/useCounterStore.js
import { create } from 'zustand';

const useCounterStore = create((set, get) => ({
  count: 0,
  increase: () => set((state) => ({ count: state.count + 1 })),
  decrease: () => set((state) => ({ count: state.count - 1 })),
  getCount: () => get().count,  // 新增此行以便讀取狀態
}));

export default useCounterStore;
